import CfCLogo from '@/assets/branding/codeforchange/CodeForChangeLogo.png';

const colors = {
  // Brand colors
  brand_primary: '#137DC5',
  brand_primary_hover: '#155E8D', // −10 L, −8 S
  brand_primary_highlight: '#56B6F5', // +23 L, +7 S
  brand_primary_mid: '#1495EB', // +8 L,  +2 S
  brand_primary_dark: '#09324E', // −25 L, −3 S (clamped)
  brand_secondary: '#154974', // hue +4°, −15 L, −13 S
  brand_accent_start: '#2391D8',
  brand_accent_end: '#6D63E0',
  brand_accent_light_start: '#EBF6FE',
  brand_accent_light_end: '#E8E8FF',
  brand_complementary_accent: 'rgb(218,101,21)',
  brand_auth_gradient_mid: '#154974',
  brand_auth_gradient_end: '#09324E',
  brand_auth_warp_mid: '#1495EB',
};

export default {
  name: 'Code for Change',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CfCLogo,
  colors,
};
